import React from 'react';
import FormCard from '../../../../../../components/FormCard';
import FormRow from '../../../../../../components/FormRow';
import Field from '../../../../../../components/Field';
import styles from '../../../../css/inventoryItemDetail.module.css';

export default function FSDescriptionCard({ f, errors = {} }) {
  return (
    <FormCard>
      <FormRow className={styles.row}>
        <Field label="Description" error={errors?.note}>
          <input
            className={styles.tallInput}
            type="text"
            value={f.note}
            onChange={e => f.setNote(e.target.value)}
            placeholder="Enter description"
            style={{ fontSize: '1rem', fontFamily: 'inherit' }}
          />
        </Field>
      </FormRow>
    </FormCard>
  );
}
